export type ConvertedToObjectType<T> = {
  [P in keyof T]: T[P] extends string ? string : ConvertedToObjectType<T[P]>;
};

/**

 If you don't want non-existing keys to throw ts error you can simply do(also keeping the intellisense)

 export type ConvertedToObjectType<T> = {
  [P in keyof T]: T[P] extends string ? string : ConvertedToObjectType<T[P]>;
} & {
  [P: string]: any;
};

 */

// Selecting the json file that our intellisense would pick from
export type TranslationJsonType = typeof import('./en/translation.json');

export enum biType {
  CONTRACTINFO = 'contractInfo',
  DEPOSIT = 'deposit',
  OTHERREIMBURSEMENT = 'reimbursement',
  RECURRING = 'recurring',
  PREVIOUSRECURRING = 'previousRecurring',
  ONEOFF = 'oneOff',
  WAIVER = 'waiver',
  TERMINATION = 'termination',
  CHANGEBILLDATE = 'changeBillDate'
}

export enum biStatus {
  PENDING = 'Pending',
  COMPLETE = 'Complete',
  AUTOComplete = 'Auto',
  NA = 'NA',
  TBC = 'TBC',
  VOIDED = 'voided',
  RENEWEDOP = 'renewedOP',
  RENEWEDOPReminder = 'renewedOPReminder',
}

export enum contractType {
  NEW = 'New',
  RENEW = 'Renew',
  OPENCONTRACT = 'Open Contract'
}